import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const CSVIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* <mask
      id="mask0_6952_15896"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="20"
      height="24"
    > */}
    <path
      d="M2.95311 23.6211C2.74628 23.6211 2.57812 23.4531 2.57812 23.2461V0.746792C2.57812 0.539799 2.74628 0.371803 2.95311 0.371803H15.5475L21.3276 6.15188V23.2461C21.3276 23.4531 21.1594 23.6211 20.9526 23.6211H2.95311Z"
      fill="white"
    />
    {/* </mask> */}
    <g mask="url(#mask0_6952_15896)">
      <path
        d="M2.95311 23.6211C2.74628 23.6211 2.57812 23.4531 2.57812 23.2461V0.746792C2.57812 0.539799 2.74628 0.371803 2.95311 0.371803H15.5475L21.3276 6.15188V23.2461C21.3276 23.4531 21.1594 23.6211 20.9526 23.6211H2.95311Z"
        fill="white"
      />
    </g>
    <path
      d="M15.7027 0.000736237H2.9531C2.53886 0.000736237 2.20312 0.336725 2.20312 0.750713V23.25C2.20312 23.664 2.53886 24 2.9531 24H20.9526C21.3668 24 21.7025 23.664 21.7025 23.25V6.00055L15.7027 0.000736237ZM15.3921 0.750713L20.9526 6.31104V23.25H2.9531V0.750713H15.3921Z"
      fill="#AEB3B7"
    />
    <path
      d="M21.7029 6.75H15.7031C15.2889 6.75 14.9531 6.41401 14.9531 6.00002V0.00020647"
      fill="#AEB3B7"
    />
    <path
      d="M22.2143 21H1.78571C1.35173 21 1 20.552 1 20V14C1 13.448 1.35173 13 1.78571 13H22.2143C22.6482 13 23 13.448 23 14V20C23 20.552 22.6482 21 22.2143 21Z"
      fill="#21824D"
    />
    <path
      d="M9.2923 19.1878C8.9493 19.3543 8.50038 19.4375 7.94638 19.4375C7.2234 19.4375 6.65511 19.2257 6.2415 18.8003C5.82789 18.3757 5.62109 17.81 5.62109 17.103C5.62109 16.3497 5.85396 15.7386 6.31885 15.2703C6.78459 14.8021 7.38817 14.5675 8.12964 14.5675C8.58949 14.5675 8.97704 14.6255 9.2923 14.7415V15.7629C8.97704 15.5746 8.61807 15.4805 8.21539 15.4805C7.77404 15.4805 7.41676 15.62 7.14438 15.8974C6.87368 16.1749 6.73751 16.5523 6.73751 17.0273C6.73751 17.4821 6.86527 17.8453 7.12168 18.116C7.37808 18.3867 7.72276 18.5212 8.15655 18.5212C8.57016 18.5212 8.9493 18.4211 9.2923 18.2194V19.1878Z"
      fill="white"
    />
    <path
      d="M10.1795 19.1744V18.1235C10.3703 18.2833 10.5771 18.4035 10.7999 18.4834C11.0235 18.5641 11.2488 18.6036 11.4766 18.6036C11.6095 18.6036 11.7263 18.5918 11.8264 18.5674C11.9264 18.543 12.0088 18.5094 12.076 18.4674C12.1433 18.4245 12.1929 18.3741 12.2257 18.3161C12.2585 18.2581 12.2744 18.195 12.2744 18.1269C12.2744 18.0353 12.2484 17.9529 12.1963 17.8806C12.1433 17.8083 12.071 17.7419 11.981 17.6805C11.8902 17.6191 11.7818 17.5603 11.6574 17.5031C11.533 17.446 11.3976 17.388 11.253 17.3291C10.8857 17.1761 10.6116 16.9886 10.4308 16.7675C10.2501 16.5464 10.1602 16.2799 10.1602 15.9664C10.1602 15.7217 10.2089 15.5099 10.3073 15.3342C10.4065 15.1585 10.541 15.0131 10.71 14.8996C10.8789 14.7852 11.0765 14.702 11.2993 14.6482C11.5229 14.5944 11.7591 14.5675 12.0088 14.5675C12.2534 14.5675 12.472 14.5826 12.6603 14.6121C12.8495 14.6415 13.0252 14.6869 13.184 14.7482V15.7302C13.1059 15.6755 13.0201 15.6268 12.9268 15.5856C12.8326 15.5444 12.7377 15.5099 12.6393 15.4821C12.5409 15.4544 12.4426 15.4342 12.3451 15.4216C12.2484 15.4082 12.1551 15.4014 12.0676 15.4014C11.9483 15.4014 11.8381 15.4132 11.7398 15.4359C11.6406 15.4595 11.5574 15.4914 11.4901 15.5326C11.4228 15.5746 11.3699 15.6242 11.332 15.6822C11.2942 15.7402 11.2766 15.8058 11.2766 15.8781C11.2766 15.9563 11.2976 16.0269 11.3388 16.09C11.38 16.1522 11.4388 16.211 11.5161 16.2665C11.5935 16.3228 11.6851 16.3775 11.7953 16.4313C11.9054 16.4851 12.0281 16.5397 12.166 16.5969C12.3552 16.6759 12.5241 16.7591 12.6738 16.8482C12.8234 16.9365 12.9529 17.0365 13.0596 17.1484C13.1664 17.2602 13.2488 17.388 13.3059 17.5309C13.3631 17.6746 13.3908 17.8419 13.3908 18.0319C13.3908 18.295 13.3421 18.5153 13.242 18.6935C13.142 18.8726 13.0067 19.0172 12.836 19.1273C12.6654 19.2374 12.467 19.3173 12.24 19.3652C12.0138 19.4131 11.7742 19.4375 11.5229 19.4375C11.2648 19.4375 11.0185 19.4156 10.7856 19.3719C10.5527 19.3274 10.3501 19.2618 10.1795 19.1744Z"
      fill="white"
    />
    <path
      d="M18.3756 14.5675L16.6975 19.4375H15.455L13.7969 14.5675H14.9794L15.9949 17.9568C16.0489 18.1402 16.0819 18.302 16.0932 18.4428H16.1132C16.1297 18.2915 16.1645 18.1246 16.2193 17.9437L17.2279 14.5675H18.3756Z"
      fill="white"
    />
  </SvgIcon>
);

export default CSVIcon;
